import { useQuery } from 'react-query';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { PowerStationPerformanceData } from '../types/DailyReportPerformanceChart.types';

const API_URL = 'api/daily-report/performance-chart';

const fetchPerformanceChartData = async (
  selectedDate: string | null,
  powerStationIds?: number[] | null
): Promise<PowerStationPerformanceData[]> => {
  if (!selectedDate) {
    throw new Error('Data não selecionada');
  }

  try {
    const params = new URLSearchParams();
    params.append('selectedDate', selectedDate);
    if (powerStationIds && powerStationIds.length > 0) {
      powerStationIds.forEach((id) => params.append('powerStationIds', String(id)));
    }

    const response = await axios.get<PowerStationPerformanceData[]>(
      API_URL,
      {
        params,
        timeout: 30000,
      }
    );

    return response.data || [];
  } catch (error) {
    console.error('Erro ao buscar dados de performance do gráfico:', error);
    return Promise.reject(error);
  }
};

export const useDailyReportPerformanceChartQuery = (
  selectedDate: string | null,
  powerStationIds?: number[] | null
) => {
  const { enqueueSnackbar } = useSnackbar();

  return useQuery({
    queryKey: ['daily-report-performance-chart', selectedDate, powerStationIds],
    queryFn: () => fetchPerformanceChartData(selectedDate, powerStationIds),
    enabled: !!selectedDate,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        'Erro ao carregar dados de performance das usinas';
      enqueueSnackbar(errorMessage, {
        variant: 'error',
        autoHideDuration: 3000,
      });
    },
  });
};
